import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import './shared/styles/globals.css';
import App from './app';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

/**
 * ClerkProvider must sit *outside* <StrictMode>. In dev, Strict Mode double-mounts
 * children; if ClerkProvider is inside it, Clerk can stay stuck with isLoaded: false.
 */
createRoot(document.getElementById('root')!).render(
  <ClerkProvider publishableKey={publishableKey ?? ''} afterSignOutUrl="/">
    <StrictMode>
      <App />
    </StrictMode>
  </ClerkProvider>
);
